export const VIEW_MODE = 'app/components/LocationSelect/VIEW_MODE';
export const EDIT_MODE = 'app/components/LocationSelect/EDIT_MODE';

export const CREATE_LOCATION = 'app/components/LocationSelect/CREATE_LOCATION';
export const SET_MODE = 'app/components/LocationSelect/SET_MODE';
export const SWITCH_TO_EDIT_MODE = 'app/components/LocationSelect/SWITCH_TO_EDIT_MODE';
export const SWITCH_TO_VIEW_MODE = 'app/components/LocationSelect/SWITCH_TO_VIEW_MODE';
